import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router';
import { Toaster } from 'sonner';
import { useTema } from '@/lib/tema';
import { Boton } from '@/ui/boton';
import { ProveedorAyuda } from '@/ui/menu';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Raiz,
  notFoundComponent: NoEncontrada,
});

function Raiz() {
  const { efectivo } = useTema();
  return (
    <ProveedorAyuda delayDuration={400} skipDelayDuration={200}>
      <Outlet />
      <Toaster
        theme={efectivo === 'oscuro' ? 'dark' : 'light'}
        position="bottom-right"
        closeButton
        richColors={false}
        toastOptions={{
          classNames: {
            toast:
              'font-sans! rounded-[14px]! border! border-border! bg-surface! text-text! shadow-[0_12px_32px_-8px_rgb(26_23_24/0.3)]!',
            description: 'text-text-2!',
            actionButton: 'bg-primary! text-on-primary! font-bold! rounded-[8px]!',
            error: '[&_[data-icon]]:text-que-strong!',
            success: '[&_[data-icon]]:text-sin-strong!',
            warning: '[&_[data-icon]]:text-ray-strong!',
          },
        }}
      />
    </ProveedorAyuda>
  );
}

function NoEncontrada() {
  return (
    <div className="grid min-h-[60dvh] place-items-center p-6">
      <div className="flex max-w-md flex-col items-center gap-3 text-center">
        <p className="patente text-[64px] text-text-2/50">4·04</p>
        <h1 className="titulo text-2xl">No encontramos esta página</h1>
        <p className="text-text-2">Puede que el enlace esté incompleto o que ya no exista.</p>
        <Boton asChild variante="primario" className="mt-2">
          <Link to="/">Ir al inicio</Link>
        </Boton>
      </div>
    </div>
  );
}
